<template>
  <div>
    <b-overlay
      :show="isLoading"
      rounded="sm"
    >
      <section id="dashboard-ecommerce">
        <b-row
          class="match-height mb-2 justify-content-between"
          v-if="userData.role === 'admin'"
        >
          <b-col
            cols="12"
            md="6"
            lg="6"
          >
            <div class="d-flex align-items-center">
              <div>
                <b-dropdown
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  text="Filter Your Partner"
                  variant="outline-primary"
                  ref="dropdown"
                  toggle="manual"
                >
                  <b-dropdown-item @click="handleFilterPartner(null)"
                    >All Partner</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-for="(item, index) in partners"
                    :key="index"
                    @click="handleFilterPartner(item)"
                    >{{ item.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>

              <b-form-group
                class="mb-0 ml-2"
                label-for="form-date"
              >
                <b-input-group class="input-group-merge">
                  <flat-pickr
                    id="form-date"
                    v-model="rangeDate"
                    class="form-control bg-white"
                    :config="{ mode: 'range' }"
                    placeholder="Select Date..."
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      icon="XCircleIcon"
                      class="cursor-pointer text-danger"
                      @click="handleClearDateRange"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
          </b-col>
          <!-- <b-col cols="2">
            <b-dropdown
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              text="Download Laporan"
              variant="outline-primary"
            >
              <b-dropdown-item> Option 1 </b-dropdown-item>
              <b-dropdown-item> Option 2 </b-dropdown-item>
              <b-dropdown-item> Option 3 </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item>Separated link</b-dropdown-item>
            </b-dropdown>
          </b-col> -->
        </b-row>

        <b-row class="match-height">
          <b-col lg="4">
            <ecommerce-browser-states
              :userStatistics="dashboard.userStatistics"
              :selectedPartner="selectedPartner"
            />
          </b-col>
          <b-col lg="8">
            <b-row class="">
              <b-col cols="12">
                <ecommerce-statistics :data="data.statisticsItems" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="match-height">
          <!-- Table Partners -->
          <b-col lg="12">
            <b-card-code no-body>
              <page-views-table :table-data="dashboard.pages" />
            </b-card-code>
          </b-col>
          <b-col lg="12">
            <b-card-code no-body>
              <ecommerce-company-table :table-data="dashboard.partners" />
            </b-card-code>
          </b-col>
          <!--/ Table Partners -->
        </b-row>
      </section>
    </b-overlay>
    <!-- <div v-else>
      <b-card title="Welcome 🚀">
        <b-card-text>All the best for your Blog.</b-card-text>
      </b-card>
    </div> -->
  </div>
</template>

<script>
import _ from 'lodash';
import {
  BCard,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BOverlay,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import { getUserData } from '@/auth/utils';
import EcommerceStatistics from './EcommerceStatistics.vue';
import EcommerceCompanyTable from './EcommerceCompanyTable.vue';
import EcommerceBrowserStates from './EcommerceBrowserStates.vue';
import PageViewsTable from './PageViewsTable.vue';
import BCardCode from '@/@core/components/b-card-code';

export default {
  components: {
    BRow,
    BCol,
    BCard,

    EcommerceStatistics,
    // EcommerceEarningsChart,
    EcommerceCompanyTable,
    EcommerceBrowserStates,
    PageViewsTable,

    BDropdown,
    BDropdownItem,
    BDropdownDivider,

    BCardCode,
    BOverlay,

    BFormGroup,
    flatPickr,

    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  data() {
    const date = new Date();
    const sevenDaysAgoDate = new Date();
    sevenDaysAgoDate.setDate(sevenDaysAgoDate.getDate() - 7);

    const sevenDaysAgoFormattedDate = sevenDaysAgoDate
      .toISOString()
      .split('T')[0];
    const currentFormattedDate = date.toISOString().split('T')[0];

    const userData = getUserData();

    return {
      sevenDaysAgoFormattedDate,
      currentFormattedDate,
      userData,
      data: {
        statisticsItems: [
          {
            icon: 'TrendingUpIcon',
            color: 'light-primary',
            title: '',
            subtitle: 'User',
            customClass: 'mb-2 mb-xl-0',
          },
          {
            icon: 'UserIcon',
            color: 'light-info',
            title: '',
            subtitle: 'Banner',
            customClass: 'mb-2 mb-xl-0',
          },
          {
            icon: 'BoxIcon',
            color: 'light-danger',
            title: '',
            subtitle: 'Post',
            customClass: 'mb-2 mb-sm-0',
          },
          {
            icon: 'DollarSignIcon',
            color: 'light-success',
            title: '',
            subtitle: 'Total Visitor',
            customClass: '',
          },
        ],
      },
      dashboard: {
        partners: [],
        pages: [],
        userStatistics: null,
        pageStatistics: null,
      },
      isLoading: true,
      rangeDate: null,
      filter: {
        partnerId: null,
      },
      partners: [],
      selectedPartner: null,
    };
  },
  watch: {
    rangeDate: {
      handler: _.debounce(function (date) {
        this.isLoading = true;
        this.getDataStatistics();
      }, 300),
      deep: true,
    },
  },
  created() {},
  mounted() {
    if (this.userData.role === 'admin') {
      this.getPartners();
    }
    this.getDataStatistics();

    setInterval(() => {
      this.getPartnerStatistics(),
        this.getUserStatistics(),
        this.getPageStatistics();
    }, 300000);
  },
  methods: {
    getPartners() {
      const queryParams = {};

      queryParams.limit = 100;

      this.$http
        .get('/admin/partners', {
          params: queryParams,
        })
        .then((response) => {
          this.partners = response.data.data.items;
        });
    },
    handleFilterPartner(item) {
      this.filter.partnerId = item._id || null;
      this.selectedPartner = item;

      this.isLoading = true;

      setTimeout(() => {
        this.getDataStatistics();
      }, 300);
    },
    handleClearDateRange() {
      this.rangeDate = null;
    },
    getDataStatistics() {
      Promise.all([
        this.getPartnerStatistics(),
        this.getUserStatistics(),
        this.getPageStatistics(),
      ]).finally(() => {
        this.isLoading = false;
      });
    },
    async getPageStatistics() {
      const { role, partner } = this.userData;

      const queryParams = {};
      queryParams.limit = 100;

      if (this.rangeDate) {
        const [startDate, endDate] = this.rangeDate?.split(' to ');
        queryParams.startDate = startDate || this.sevenDaysAgoFormattedDate;
        queryParams.endDate = endDate || this.currentFormattedDate;
      }

      if (this.filter.partnerId) {
        queryParams.partnerId = this.filter.partnerId;
      } else {
        queryParams.partnerId =
          role === 'admin' ? null : this.userData.partner._id;
      }

      const response = await this.$http.get(
        '/admin/dashboard/page-statistics',
        {
          params: queryParams,
        }
      );

      if (response) {
        const data = response.data.data;

        this.dashboard.pages = Array.isArray(data) ? data : [data];
      }
    },
    async getPartnerStatistics() {
      const { role, partner } = this.userData;

      const queryParams = {};
      queryParams.limit = 100;

      if (this.rangeDate) {
        const [startDate, endDate] = this.rangeDate?.split(' to ');
        queryParams.startDate = startDate || this.sevenDaysAgoFormattedDate;
        queryParams.endDate = endDate || this.currentFormattedDate;
      }

      if (this.filter.partnerId) {
        queryParams.partnerId = this.filter.partnerId;
      } else {
        queryParams.partnerId =
          role === 'admin' ? null : this.userData.partner._id;
      }

      const response = await this.$http.get('/admin/dashboard/partners', {
        params: queryParams,
      });

      if (response) {
        const data = response.data.data;

        this.dashboard.partners = Array.isArray(data) ? data : [data];

        const totalBanners = this.dashboard.partners.reduce(
          (sum, partner) => sum + (partner.totalBanners || 0),
          0
        );
        const totalPosts = this.dashboard.partners.reduce(
          (sum, partner) => sum + (partner.totalPosts || 0),
          0
        );
        const totalUsers = this.dashboard.partners.reduce(
          (sum, partner) => sum + (partner.totalUsers || 0),
          0
        );

        this.data.statisticsItems = [
          {
            icon: 'TrendingUpIcon',
            color: 'light-primary',
            title: totalUsers,
            subtitle: 'User',
            customClass: 'mb-2 mb-xl-0',
          },
          {
            icon: 'UserIcon',
            color: 'light-info',
            title: totalBanners,
            subtitle: 'Banner',
            customClass: 'mb-2 mb-xl-0',
          },
          {
            icon: 'BoxIcon',
            color: 'light-danger',
            title: totalPosts,
            subtitle: 'Post',
            customClass: 'mb-2 mb-sm-0',
          },
          // {
          //   icon: 'DollarSignIcon',
          //   color: 'light-success',
          //   title: this.dashboard.partners[0].totalRevenue,
          //   subtitle: 'Revenue',
          //   customClass: '',
          // },
        ];
      }
    },
    async getUserStatistics() {
      const { role, partner } = this.userData;

      const queryParams = {};
      queryParams.limit = 100;

      if (this.rangeDate) {
        const [startDate, endDate] = this.rangeDate?.split(' to ');
        queryParams.startDate = startDate || this.sevenDaysAgoFormattedDate;
        queryParams.endDate = endDate || this.currentFormattedDate;
      }

      if (this.filter.partnerId) {
        queryParams.partnerId = this.filter.partnerId;
      } else {
        queryParams.partnerId =
          role === 'admin' ? null : this.userData.partner._id;
      }

      const response = await this.$http.get(
        '/admin/dashboard/user-statistics',
        {
          params: queryParams,
        }
      );

      if (response) {
        const data = response.data.data;

        const activeUsers = Array.isArray(data)
          ? data.reduce((sum, partner) => sum + (partner.activeUsers || 0), 0)
          : data.activeUsers;
        const newUsers = Array.isArray(data)
          ? data.reduce((sum, partner) => sum + (partner.newUsers || 0), 0)
          : data.newUsers;
        const totalUsers = Array.isArray(data)
          ? data.reduce((sum, partner) => sum + (partner.totalUsers || 0), 0)
          : data.totalUsers;

        this.dashboard.userStatistics = {
          activeUsers,
          newUsers,
          totalUsers,
        };
      }
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
